import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useModal } from 'store/modal';
import UpdateEntity from 'components/crud/UpdateEntity';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import SegmentForm from './SegmentForm';
import { ISegment } from '../types';

interface IProps {
  segmentsEntityName: string;
  segmentsEndpoint: string;
  segment: ISegment;
}

const EditForm: FC<IProps> = ({ segmentsEntityName, segmentsEndpoint, segment }: IProps) => {
  const { id } = useParams<{ id: string }>();
  const { showModal } = useModal();
  const { client } = useActiveClientContext();

  const methods = useForm({
    defaultValues: {
      ...segment,
    },
  });

  return (
    <UpdateEntity
      id={id}
      entity={segmentsEndpoint}
      methods={methods}
      onSuccess={(res: any) => {
        const { name } = res.data;
        showModal({
          type: 'success',
          content: (
            <>
              Редактирахте сегмент&nbsp;
              <span className="font-weight-bold">{name}</span>.
            </>
          ),
        });
      }}
      queryKey={[buildClientEntity(segmentsEntityName, client), { id }]}
    >
      {(update: any) => {
        return (
          <SegmentForm
            methods={methods}
            handleSubmit={data => update(data)}
            btnLabel="Запази"
            canEdit={segment.can_edit}
            isMultilingual={client?.is_multilingual}
          />
        );
      }}
    </UpdateEntity>
  );
};

export default EditForm;
